import { Pagination } from "react-bootstrap";

export interface ISimplePagination {
    activePagination?: number;
    numberMaxOfPagination?: number;
    nextPagination?(): void;
    prevPagination?(): void;
    changePagination?(number: number): void;
}

const SimplePagination = (props: ISimplePagination) => {
    const {
        activePagination = 1,
        numberMaxOfPagination = 10,
        nextPagination = () => {},
        prevPagination = () => {},
        changePagination = () => {},
    } = props;
    const paginationItems = [];

    paginationItems.push(
        <Pagination.Prev key={0} disabled={activePagination == 1} onClick={prevPagination} />
    );

    for (let number = 1; number <= numberMaxOfPagination; number++) {
        paginationItems.push(
            <Pagination.Item
                key={number}
                onClick={() => changePagination(number)}
                active={number === activePagination}
            >
                {number}
            </Pagination.Item>
        );
    }
    paginationItems.push(
        <Pagination.Next
            key={numberMaxOfPagination + 1}
            disabled={activePagination == numberMaxOfPagination}
            onClick={nextPagination}
        />
    );

    return <Pagination>{paginationItems}</Pagination>;
};

export default SimplePagination;
